import { useAuth0 } from '@auth0/auth0-react';
import useSWRImmutable from 'swr/immutable';
import { Currency } from '@/Models/Currency';
import { JobCategory } from '@/Models/JobCategory';
import http from '@/Utils/HTTP/NewHttpUtils';
import HttpError from '@/Utils/HTTP/Errors/HttpError';

export interface AssessmentSettings {
    jobCategories: JobCategory[];
    currencies: Currency[];
}

const DefaultAssessmentSettings: AssessmentSettings = {
    jobCategories: [],
    currencies: [],
};

export const useAssessmentSettings = () => {
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

    return useSWRImmutable(
        isAuthenticated ? 'settings/assessment' : null,
        async (path) => {
            const result = await http.get<AssessmentSettings>({
                path,
                accessToken: await getAccessTokenSilently(),
            });

            return result || DefaultAssessmentSettings;
        },
        {
            fallbackData: DefaultAssessmentSettings,
            // we need to reload configuration during sign up, because first call fails
            // with 403 because email is not verified yet
            shouldRetryOnError: (err) => err instanceof HttpError && err.status === 403,
        },
    );
};
